import { useContext } from "react";

import { SmartCaptchaContext } from "./SmartCaptchaContext";

export const useSmartCaptcha = () => {
  const context = useContext(SmartCaptchaContext);

  if (!context) {
    throw new Error("useSmartCaptcha must be used within SmartCaptchaProvider");
  }

  return context;
};
